import WorkspacesIcon from '@mui/icons-material/Workspaces';

/** Icon for station groups (distinct from user GroupIcon). */
export const StationGroupsIcon = WorkspacesIcon;
